import api from './client';

export const getAllHomeData = async () => {
  try {
    const res = await api.get('/home/allhomedata');
    return res.data?.data || null;
  } catch (err) {
    console.error('Home API error:', err);
    return null;
  }
};
